import React, { useEffect, useState } from 'react';
import {
    Col,
    Container,
    Row,
    Card,
    CardHeader,
    CardBody,
    Table,
    Button,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';

import logoDark from '../../assets/images/logo-dark.png';
import logoLight from '../../assets/images/logo-light.png';
import moment from 'moment';
import FeatherIcon from 'feather-icons-react';
import { translate } from '../../helpers/language_helper';

const ReceiptDetails = (props) => {
    document.title = 'Receipt Details | Kinderiffic';

    // States-E-Module
    const { user, center } = useSelector((state) => ({
        user: state.User,
        center: state.Center,
    }));
    const [Receipt, setReceipt] = useState(null);

    // Use effect
    useEffect(() => {
        try {
            axios
                .get(
                    `${process.env.REACT_APP_API_URL}/receipts/edit?auth_key=${user.auth_key}&receipt_id=${props.location.state.receipt_id}`
                )
                .then((res) => {
                    setReceipt(res);
                });
        } catch (error) {
            console.log(error);
        }
    }, []);

    //Print the Invoice
    const printNow = () => {
        window.print();
    };

    let history = useHistory();

    if (Receipt === null) return null;

    console.log(Receipt);

    const receipt = Receipt.data.receipt;
    let sub_total = parseFloat(receipt.receipt_amount);
    const receiptDetails =
        <tr>
            <th scope='row'>{1}</th>
            <td className='text-start'>
                <span className='fw-medium'>{receipt.receipt_desc}</span>
            </td>
            <td className='text-end'>{receipt.receipt_amount}</td>
            <td className='text-end'>{receipt.receipt_amount}</td>
        </tr>

    return (
        <React.Fragment>
            <div className='page-content'>
                <Container fluid>
                    <Row>
                        <Col xs={12}>
                            <div
                                className='page-title-box d-sm-flex align-items-center justify-content-between'
                                style={{ minHeight: '58px' }}>
                                <h4 className='mb-sm-0'>
                                    <FeatherIcon
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => history.goBack()}
                                        className='me-1'
                                        icon='arrow-left'
                                    />
                                    {translate('Receipt Details')}
                                </h4>
                                <div className='hstack gap-2 justify-content-end d-print-none'>
                                    <Button
                                        onClick={printNow}
                                        color='success'>
                                        <i className='ri-printer-line align-bottom me-1'></i>{' '}
                                        {translate('Print')}
                                    </Button>
                                    <Button color='primary'>
                                        <i className='ri-mail-send-line align-bottom me-1'></i>{' '}
                                        {translate('Email PDF')}
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='justify-content-center'>
                        <Col xxl={9}>
                            <Card id='demo'>
                                <Row>
                                    <Col lg={12}>
                                        <CardHeader className='border-bottom-dashed p-4'>
                                            <div className='d-flex'>
                                                <div className='flex-grow-1'>
                                                    <img
                                                        src={logoDark}
                                                        className='card-logo card-logo-dark'
                                                        alt='logo dark'
                                                        height='17'
                                                    />
                                                    <img
                                                        src={logoLight}
                                                        className='card-logo card-logo-light'
                                                        alt='logo light'
                                                        height='17'
                                                    />
                                                    <div className='mt-sm-5 mt-4'>
                                                        <h6 className='text-muted text-uppercase fw-semibold'>
                                                            {translate('Address')}
                                                        </h6>
                                                        <p
                                                            className='text-muted mb-1'
                                                            id='address-details'>
                                                            {center.address}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className='flex-shrink-0 mt-sm-0 mt-3'>
                                                    <h6>
                                                        <span className='text-muted fw-normal'>
                                                            {translate('Email:')}
                                                        </span>{' '}
                                                        <span id='email'>
                                                            {center.email1}
                                                        </span>
                                                    </h6>
                                                    <h6>
                                                        <span className='text-muted fw-normal'>
                                                            {translate('Website:')}
                                                        </span>{' '}
                                                        <Link
                                                            to={center.urlwww}
                                                            className='link-primary'
                                                            id='website'>
                                                            {center.urlwww}
                                                        </Link>
                                                    </h6>
                                                    <h6 className='mb-0'>
                                                        <span className='text-muted fw-normal'>
                                                            {translate('Contact No:')}
                                                        </span>{' '}
                                                        <span id='contact-no'>
                                                            {' '}
                                                            {center.phone1}
                                                        </span>
                                                    </h6>
                                                </div>
                                            </div>
                                        </CardHeader>
                                    </Col>
                                    <Col lg={12}>
                                        <CardBody className='p-4'>
                                            <Row className='g-3'>
                                                <Col lg={3} xs={6}>
                                                    <p className='text-muted mb-2 text-uppercase fw-semibold'>
                                                        {translate('Receipt No')}
                                                    </p>
                                                    <h5 className='fs-14 mb-0'>
                                                        <span id='invoice-no'>
                                                            {receipt.receipt_num}
                                                        </span>
                                                    </h5>
                                                </Col>
                                                <Col lg={3} xs={6}>
                                                    <p className='text-muted mb-2 text-uppercase fw-semibold'>
                                                        {translate('Date')}
                                                    </p>
                                                    <h5 className='fs-14 mb-0'>
                                                        <span id='invoice-date'>
                                                            {(receipt.updated_on) ? moment(receipt.updated_on).format('DD-MM-YYYY') : moment(receipt.created_on).format('DD-MM-YYYY')}
                                                        </span>
                                                    </h5>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Col>
                                    <Col lg={12}>
                                        <CardBody className='p-4 border-top border-top-dashed'>
                                            <Row className='g-3'>
                                                <Col sm={6}>
                                                    <h6 className='text-muted text-uppercase fw-semibold mb-3'>
                                                        {translate('Received from')}
                                                    </h6>
                                                    <p
                                                        className='fw-medium mb-2'
                                                        id='billing-name'>
                                                        {receipt.parent_name}
                                                    </p>
                                                    {receipt.address && (
                                                        <p className='text-muted mb-1'>
                                                            {receipt.address}
                                                        </p>
                                                    )}
                                                    {receipt.parent_country && (
                                                        <p className='text-muted mb-1'>
                                                            {
                                                                receipt.parent_country
                                                            }
                                                        </p>
                                                    )}
                                                    {receipt.email1 && (
                                                        <p className='text-muted mb-1'>
                                                            {receipt.email1}
                                                        </p>
                                                    )}
                                                    {receipt.phone1 && (
                                                        <p className='text-muted mb-1'>
                                                            {receipt.phone1}
                                                        </p>
                                                    )}
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Col>
                                    <Col lg={12}>
                                        <CardBody className='p-4'>
                                            <div className='table-responsive'>
                                                <Table className='table-borderless text-center table-nowrap align-middle mb-0'>
                                                    <thead>
                                                        <tr className='table-active'>
                                                            <th
                                                                scope='col'
                                                                style={{
                                                                    width: '50px',
                                                                }}>
                                                                #
                                                            </th>
                                                            <th className='text-start' scope='col'>
                                                                {translate('Description')}
                                                            </th>
                                                            <th
                                                                scope='col'
                                                                className='text-end'>
                                                                {translate('Amount')}
                                                            </th>
                                                            <th
                                                                scope='col'
                                                                className='text-end'>
                                                                {translate('Total')}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id='products-list'>
                                                        {receiptDetails}
                                                    </tbody>
                                                </Table>
                                            </div>
                                            <div className='border-top border-top-dashed mt-2'>
                                                <Table
                                                    className='table table-borderless table-nowrap align-middle mb-0 ms-auto'
                                                    style={{
                                                        width: '250px',
                                                    }}>
                                                    <tbody>
                                                        <tr>
                                                            <td>{translate('Sub Total')}</td>
                                                            <td className='text-end'>
                                                                {sub_total.toFixed(2)}
                                                            </td>
                                                        </tr>
                                                        <tr className='border-top border-top-dashed fs-15'>
                                                            <th scope='row'>
                                                                {translate('Total Amount')}
                                                            </th>
                                                            <th className='text-end'>
                                                                {
                                                                    parseFloat(receipt.receipt_amount).toFixed(2)
                                                                }
                                                            </th>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </CardBody>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ReceiptDetails;
